import { AuthProvider } from './context/AuthContext';
import { createRoot } from 'react-dom/client';
import './index.css';
import { RouterProvider } from 'react-router-dom';
import { routes } from './routes/routes';

import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://361ec98be4e4e381330cd6ee346472da@o4509629006872576.ingest.de.sentry.io/4509629026336848',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <AuthProvider>
    <RouterProvider router={routes} />
  </AuthProvider>
);

